import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LearningDomainApi } from '../+api';

import { LearningDomainInterface } from '../+models';
import { DAL_OPTIONS, DalOptions } from '../dal.module';
import { LearningDomainServiceInterface } from './learning-domain.service.interface';

@Injectable({
  providedIn: 'root',
})
export class LearningDomainService implements LearningDomainServiceInterface {
  private http = inject(HttpClient);
  private dalOptions = inject<DalOptions>(DAL_OPTIONS);
  private learningDomainApi = inject(LearningDomainApi);

  getAll(): Observable<LearningDomainInterface[]> {
    return this.learningDomainApi.find();
  }

  getLearningDomainsWithTopics(goalGroupId: number): Observable<LearningDomainInterface[]> {
    const { apiBaseUrl } = this.dalOptions;
    const url = `${apiBaseUrl}/api/LearningDomains/learningdomains-with-goaltopics`;

    return this.http.get<LearningDomainInterface[]>(url, {
      params: {
        goalGroupId: goalGroupId.toString(),
      },
      withCredentials: true,
    });
  }

  getLearningDomains$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: LearningDomainInterface[]; count: number }> {
    const params = new HttpParams({
      fromObject: {
        searchTerm: searchTerm || '',
        filters: JSON.stringify(filters || {}),
        columns: JSON.stringify(columns || null),
        sorting: JSON.stringify(sorting || {}),
        pagination: JSON.stringify(pagination || {}),
      },
    });
    return this.learningDomainApi.getLearningDomains(params);
  }

  createLearningDomain(learningDomain: LearningDomainInterface): Observable<LearningDomainInterface> {
    return this.learningDomainApi.createLearningDomain(learningDomain);
  }

  updateLearningDomain(learningDomain: LearningDomainInterface): Observable<LearningDomainInterface> {
    const params = new HttpParams({
      fromObject: {
        id: learningDomain.id?.toString(),
      },
    });
    return this.learningDomainApi.updateLearningDomain(params, learningDomain);
  }

  deleteLearningDomain(learningDomain: LearningDomainInterface): Observable<boolean> {
    return this.learningDomainApi.deleteById(learningDomain.id);
  }
}
